// A snowy owl, modelled facing +X: a round white body flecked dark, a broad head
// and amber eyes. Ported 1:1 from age-of-mcp's classic snowy-owl.ts.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  return [
    { geometry: new THREE.IcosahedronGeometry(0.045, 0), color: "#f4f6f8",
      position: [0, 0.035, 0], scale: [1, 1.2, 0.95] },             // body
    { geometry: new THREE.IcosahedronGeometry(0.036, 0), color: "#ffffff",
      position: [0.012, 0.09, 0] },                                 // head
    { geometry: new THREE.IcosahedronGeometry(0.012, 0), color: "#f0a824",
      position: [0.034, 0.095, 0.015] },                            // eye
    { geometry: new THREE.IcosahedronGeometry(0.012, 0), color: "#f0a824",
      position: [0.034, 0.095, -0.015] },
    { geometry: new THREE.ConeGeometry(0.007, 0.016, 4), color: "#3a322a",
      position: [0.046, 0.09, 0], rotation: [0, 0, -Math.PI / 2] },    // beak
    { geometry: new THREE.IcosahedronGeometry(0.006, 0), color: "#9a9a9a",
      position: [-0.02, 0.05, 0.02] },                              // dark fleck
    { geometry: new THREE.IcosahedronGeometry(0.006, 0), color: "#9a9a9a",
      position: [-0.015, 0.025, -0.018] },
    { geometry: new THREE.IcosahedronGeometry(0.02, 0), color: "#ededed",
      position: [-0.012, 0.04, 0.038], scale: [1, 1.6, 0.4] },       // folded wing
    { geometry: new THREE.IcosahedronGeometry(0.02, 0), color: "#ededed",
      position: [-0.012, 0.04, -0.038], scale: [1, 1.6, 0.4] },
  ];
}

export const snowyOwl = defineModel({
  id: "snowy-owl",
  batchId: "standard",
  name: "Snowy owl",
  tags: ["creature","snowy","owl","low-poly","age-of-mcp","classic"],
  summary: "Low-poly snowy owl.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.09,
  parts: () => partsFor(),
  animations: [],
});
